angular.module('picmonicng').filter('oddIndex', function () {
  return function (input) {
    var toReturn = [];
    for (a in input) {
      if (a != 0 && a % 2) {
        toReturn.push(input[a]);
      }
    }

    return toReturn;
  };
});
